import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdCustomDomains = "/companies/:company_id/custom_domains";

export const companiesCompanyIdCustomDomainsCacheKeys: AllRouteEndpoints[] = [companiesCompanyIdCustomDomains];
